import React, { useRef } from "react";
import { RiMenu4Fill } from "react-icons/ri";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const LandingPage = () => {
  const container = useRef();

  useGSAP(() => {
    const tl = gsap.timeline({ defaults: { ease: "power3.out" } });

    tl.from("nav", { y: -50, opacity: 0, duration: 1 })
      .from("header > *", { y: 30, opacity: 0, stagger: 0.1, duration: 0.8 }, "-=0.5")
      .from("aside img", { scale: 0.5, opacity: 0, stagger: 0.05, duration: 1, ease: "back.out(1.7)" }, "-=1");

    // Floating effect for side images
    gsap.to("aside .flex-col", {
      y: (i) => (i % 2 === 0 ? -30 : 30),
      duration: 3,
      repeat: -1,
      yoyo: true,
      ease: "sine.inOut",
    });
  }, { scope: container });

  return (
    <div ref={container} className="mx-auto w-full relative overflow-hidden min-h-screen bg-slate-950">
      <nav className="flex justify-between items-center lg:p-8 p-5 relative z-20 backdrop-blur-xl border-b border-white/5">
        <div className="flex items-center justify-start gap-10">
          <div className="md:block hidden text-3xl font-black tracking-[10px] bg-clip-text text-transparent bg-gradient-to-r from-indigo-400 to-cyan-400">
            AI.GEN
          </div>
          <div className="md:hidden text-2xl font-bold tracking-[8px]">
            AVATAR. AI
          </div>
          <ul className="hidden list-none md:flex gap-8 text-sm font-medium uppercase tracking-widest text-slate-400">
            <li className="hover:text-white transition-colors cursor-pointer">
              <a href="#features" data-scroll-to>Features</a>
            </li>
            <li className="hover:text-white transition-colors cursor-pointer">
              <a href="#roadmap" data-scroll-to>Roadmap</a>
            </li>
            <li className="hover:text-white transition-colors cursor-pointer">
              <a href="#tokenomics" data-scroll-to>Tokenomics</a>
            </li>
          </ul>
        </div>
        <div className="md:flex hidden gap-4">
          <button className="rounded-xl py-3 px-8 font-semibold border border-white/10 backdrop-blur-md bg-white/5 hover:bg-white/10 transition-all">
            Whitepaper
          </button>
          <button className="bg-gradient-to-r from-indigo-600 to-pink-600 rounded-xl py-3 px-8 font-semibold shadow-[0_0_20px_rgba(79,70,229,0.4)] hover:shadow-[0_0_30px_rgba(79,70,229,0.6)] transition-all">
            Get Started
          </button>
        </div>
        <button className="md:hidden text-xl p-3 rounded-full bg-white/5 cursor-pointer">
          <RiMenu4Fill />
        </button>
      </nav>
      <div className="md:flex lg:p-20 p-5 relative items-center min-h-[calc(100vh-100px)]">
        <header className="md:w-[50%] lg:ml-44 ml-0 relative z-10">
          <button className="mb-8 border border-indigo-500/30 px-4 py-2 text-xs font-bold rounded-full bg-indigo-500/10 text-indigo-300 uppercase tracking-widest animate-pulse">
            🎉 New in AI.GEN: Real Time Interaction
          </button>
          <h1 className="lg:text-6xl text-4xl font-black leading-tight">
            IOTA polygon serum <br/>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400">
              WAX terraUSD gala
            </span>
          </h1>
          <p className="text-xl mt-8 text-slate-400 max-w-xl leading-relaxed">
            Chiliz serum TRON dash aave cardano crypto celo. Golem ankr bancor
            horizen ethereum quant bitcoin.
          </p>
          <button className="bg-gradient-to-r from-indigo-600 to-pink-600 rounded-2xl py-5 px-12 font-bold text-lg mt-12 shadow-[0_10px_40px_rgba(79,70,229,0.4)] hover:scale-105 transition-transform">
            Get Started
          </button>
        </header>
        <aside className="flex md:relative absolute top-0 justify-center opacity-10 lg:opacity-100 items-center right-0 lg:top-[-50px] lg:right-[-120px] -z-1 gap-12 pointer-events-none select-none">
          <div className="flex flex-col gap-10">
            <img src="/elonMusk.png" alt="Profile 1" className="w-56 h-56 object-cover rounded-[3rem] shadow-2xl border border-white/10" />
            <img src="/billGates.png" alt="Profile 2" className="w-56 h-56 object-cover rounded-[3rem] shadow-2xl border border-white/10" />
            <img src="/person3.png" alt="Profile 3" className="w-56 h-56 object-cover rounded-[3rem] shadow-2xl border border-white/10" />
          </div>
          <div className="relative bottom-32 flex flex-col gap-10">
            <img src="/elonMusk.png" alt="Profile 1" className="w-56 h-56 object-cover rounded-[3rem] shadow-2xl border border-white/10" />
            <img src="/billGates.png" alt="Profile 2" className="w-56 h-56 object-cover rounded-[3rem] shadow-2xl border border-white/10" />
            <img src="/person3.png" alt="Profile 3" className="w-56 h-56 object-cover rounded-[3rem] shadow-2xl border border-white/10" />
          </div>
          <div className="flex flex-col gap-10">
            <img src="/elonMusk.png" alt="Profile 1" className="w-56 h-56 object-cover rounded-[3rem] shadow-2xl border border-white/10" />
            <img src="/billGates.png" alt="Profile 2" className="w-56 h-56 object-cover rounded-[3rem] shadow-2xl border border-white/10" />
            <img src="/person3.png" alt="Profile 3" className="w-56 h-56 object-cover rounded-[3rem] shadow-2xl border border-white/10" />
          </div>
        </aside>
      </div>
    </div>
  );
};

export default LandingPage;
